import {
  TextCustom
} from '@vw-marketing/us-components';
import React from 'react';
import { StyledReviewsDisclaimer } from './styles';
import { disclaimerTextStyle, disclaimerTitleStyle, noReviewsTextStyle } from './helpers';
import { useFeatureAppConfig } from '../../services/use-feature-app-config';

interface DisclaimerSectionProps {
  disclaimer: string;
  hasReviews?: boolean;
}
const NO_DEALER_REVIEWS = "No Reviews at the moment";
const DisclaimerSection: React.FC<DisclaimerSectionProps> = ({
  disclaimer,
  hasReviews
}) => {
  const {dealerNoReviewsLabel = NO_DEALER_REVIEWS} = useFeatureAppConfig().fiveStarsConfig || {}; 
  return (
    <StyledReviewsDisclaimer>
      <div className="disclaimer-title">
        <TextCustom {...disclaimerTitleStyle}>{'Reviews'}</TextCustom>
      </div>
      {hasReviews ? <div className="disclaimer-text">
        <TextCustom {...disclaimerTextStyle}>{disclaimer}</TextCustom>
      </div> : 
      <div className="no-reviews-text">
      <TextCustom {...noReviewsTextStyle}>{dealerNoReviewsLabel}</TextCustom>
    </div>
      }
    </StyledReviewsDisclaimer>
  );
};

export default DisclaimerSection;
